import { render, staticRenderFns } from "./GeneralExercises.vue?vue&type=template&id=536393f2&scoped=true&"
import script from "./GeneralExercises.vue?vue&type=script&lang=js&"
export * from "./GeneralExercises.vue?vue&type=script&lang=js&"
import style0 from "./GeneralExercises.vue?vue&type=style&index=0&id=536393f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536393f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
